import { callApi } from "./api";
import * as transforms from "./transforms";

function transformProductVariationResponse(response) {
  const result = {
    design: null,
    product_variant: null,
  };

  if (response.field_product_variant.length) {
    result.product_variant = transforms.transformProductVariant(
      response.field_product_variant[0],
    );
  }

  if (response.field_design.length) {
    result.design = transforms.transformDesign(response.field_design[0]);
    result.product_variant.options.push(
      transforms.transformProductOption(
        response.field_design[0].field_product_option,
      ),
    );
  }

  return result;
}

// api services
export const fetchProductVariation = (id) => {
  return callApi("productvariation/" + id).then((response) => {
    if (response.response && response.response.length) {
      return {
        response: transformProductVariationResponse(response.response[0]),
      };
    } else {
      return { response: {} };
    }
  });
};

export const createProductVariation = (data) => {
  const params = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    credentials: "include",
    method: "POST",
    body: "design_id=" + data.design_id + "&product_id=" + data.product_id,
  };

  let url = "create-product-variation";
  return callApi(url, params).then((response) => {
    if (response.response) {
      return { response: response.response };
    } else {
      return { error: response.error };
    }
  });
};
